import { Layout } from '@utilities';

import styles from './_index.module.scss';

const NoDataPlaceholder = () => {
  return <Layout.Flex className={styles['no-data-placeholder']}>No Data to Display</Layout.Flex>;
};

export default NoDataPlaceholder;
